import Layout from '@components/global/main/layout';
import Footer from '@components/global/main/footer';
import Company from '@data/company.json';
import Navbar from '@components/global/main/navbar';
import { useGetQuizAnswer } from '@services/auth';
import React, { useState, useEffect } from 'react';
import isEmpty from '@utils/isEmpty';
import Loader from '@components/global/loader';
import { Disclosure } from '@headlessui/react';
import Aos from 'aos';
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline';

const Faq = () => {
  const [getQuizAnswer, { loading: isLoading }] = useGetQuizAnswer();
  const [data, setData] = useState([]);

  useEffect(() => {
    if (isEmpty(data)) {
      getQuizAnswer()
        .then(async res => {
          if (res && res?.status_code === 200) {
            setData(res && res?.result);
          }
        })
        .catch(error => console.log(error));
    }
  }, []);
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <Layout>
      {isLoading && <Loader />}
      <Navbar />

      <div className="max-w-6xl mx-auto">
        <div className="pt-24 px-4 pb-4 lg:pt-32 lg:pb-8">
          <h1 className="font-semibold text-xl md:text-2xl uppercase">
            <b className="text-mainc">ЭДҮЛАЙН</b> түгээмэл асуултууд
          </h1>
        </div>
        <div className="grid grid-cols-2 items-start gap-6">
          {data &&
            data.map((quiz, i) => (
              <div
                data-aos="fade-up"
                className="bg-white/60 hover:bg-white/90 text-mainc rounded cursor-pointer hover:shadow "
                key={i}
              >
                <Disclosure>
                  {({ open }) => (
                    <>
                      <Disclosure.Button className={'w-full'}>
                        <div className="flex justify-between p-4 w-full">
                          <p
                            className={`font-medium text-left w-full ${
                              open ? '' : 'truncate pr-4'
                            }`}
                          >
                            {quiz?.question}
                          </p>
                          <div>
                            {open ? (
                              <MinusIcon className="h-5 w-5" />
                            ) : (
                              <PlusIcon className="h-5 w-5" />
                            )}
                          </div>
                        </div>
                      </Disclosure.Button>
                      <Disclosure.Panel>
                        <p className="p-4 pt-0 text-sm text-gray-800">
                          {quiz?.answer}
                        </p>
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              </div>
            ))}
        </div>
      </div>

      <Footer companyInfo={Company} />
    </Layout>
  );
};

export default Faq;
